import { Navigate, ToolbarProps, View } from 'react-big-calendar';
import cx from 'clsx';
import { Box, Button, ButtonGroup } from '@mui/material';

import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
export const CustomToolbar = ({
  date,
  label,
  localizer,
  onNavigate,
  onView,
  view,
  views,
}: ToolbarProps) => {
  const handleYearBack = () => {
    const newDate = date;
    newDate.setFullYear(date.getFullYear() - 1);
    onNavigate(Navigate.DATE, newDate);
  };
  const handleYearForward = () => {
    const newDate = date;
    newDate.setFullYear(date.getFullYear() + 1);
    onNavigate(Navigate.DATE, newDate);
  };
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='flex-start'
      mb={2}
      className='calendar-toolbar'
    >
      <ButtonGroup size='small'>
        {Array.isArray(views) &&
          views.map((name) => {
            return (
              <Button
                key={name}
                onClick={() => onView(name)}
                className={cx({ 'rbc-active': view === name })}
                variant={view === name ? 'contained' : 'outlined'}
                color='primary'
              >
                {localizer.messages[name]}
              </Button>
            );
          })}
      </ButtonGroup>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='flex-start'
        sx={{ ml: 2 }}
      >
        <ButtonGroup size='small'>
          {(view as View | 'year') !== 'year' && (
            <Button onClick={handleYearBack} variant='outlined' color='primary'>
              <KeyboardDoubleArrowLeftIcon />
            </Button>
          )}
          <Button
            onClick={() => onNavigate(Navigate.PREVIOUS)}
            variant='outlined'
            color='primary'
          >
            <KeyboardArrowLeftIcon />
          </Button>
          <Button
            onClick={() => onNavigate(Navigate.TODAY)}
            variant='outlined'
            color='primary'
          >
            {localizer.messages.today}
          </Button>
          <Button
            onClick={() => onNavigate(Navigate.NEXT)}
            variant='outlined'
            color='primary'
          >
            <KeyboardArrowRightIcon />
          </Button>
          {(view as View | 'year') !== 'year' && (
            <Button
              onClick={handleYearForward}
              variant='outlined'
              color='primary'
            >
              <KeyboardDoubleArrowRightIcon />
            </Button>
          )}
        </ButtonGroup>
        <Box className='rbc-toolbar-label' sx={{ ml: 2 }}>
          {label}
        </Box>
      </Box>
    </Box>
  );
};
